import { render, staticRenderFns } from "./limit_warning_component.vue?vue&type=template&id=561865b4&"
import script from "./limit_warning_component.vue?vue&type=script&lang=js&"
export * from "./limit_warning_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "limit_warning_component.vue"
export default component.exports